import { render, staticRenderFns } from "./auth-forgot-password.vue?vue&type=template&id=9fd3309e&scoped=true&lang=pug"
import script from "./auth-forgot-password.js?vue&type=script&lang=js&external"
export * from "./auth-forgot-password.js?vue&type=script&lang=js&external"
import style0 from "./auth-forgot-password.vue?vue&type=style&index=0&id=9fd3309e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd3309e",
  null
  
)

export default component.exports